/* @ngInject */
const go = (
  commandeLocal,
  $state,
  routes
) => {
  const self = {}

  self.new = () => {
    $state.go(routes.consult.commande.new.path)
  }

  self.consult = (_id) => {
    commandeLocal.saveCurrentId(_id)
    $state.go(routes.consult.commande.details.path)
  }

  self.edit = (_id) => {
    commandeLocal.saveCurrentId(_id)
    $state.go(routes.consult.commande.edit.path)
  }

  return self
}

export default go



// WEBPACK FOOTER //
// ./public/javascript/sygem/entities/commande/services/go.service.js